import React from 'react';
import { Flame } from 'lucide-react';
export function TopBanner() {
  return <div className="w-full bg-gradient-to-r from-purple-600 to-purple-800 text-white py-2 px-2 flex justify-center items-center shadow-sm sticky top-0 z-50" data-id="element-207">
      <div className="flex items-center gap-1.5 text-[10px] md:text-sm font-bold tracking-wide uppercase animate-pulse-slow" data-id="element-208">
        <Flame className="w-3 h-3 md:w-4 md:h-4 fill-orange-400 text-orange-400" data-id="element-209" />
        <span data-id="element-210">OFERTA LIMITADA: 60% DE DESCUENTO HOY</span>
      </div>
    </div>;
}